import React, { Children, useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../Style.css";
import axios from "axios";
import {
  Radio,
  Input,
  Table,
  Modal,
  Button,
  Space,
  Dropdown,
  message,
  List,
  Checkbox,
} from "antd";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
  EyeOutlined,
  LeftCircleOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { partnerDataSuccess } from "../../../redux/PricingPartnerDetails/PricingPartnerDetailsAction";
import { connect } from "react-redux";
import { getCategoryList } from "../../../redux/PricingSetupCategory/pricingSetupCategoryAction";
import {
  addPricingStageByPartner,
  getPartnerPricingDataByStage,
} from "../../../redux/PartnerPicingdatabystage/action";
import TextArea from "antd/lib/input/TextArea";
import { Payout_Service } from "../../../redux/Url";
import { data } from "../helper/PricingdashboardData";
import Logout from "../../../containers/Pages/Login/Logout";
import { render } from "@testing-library/react";
import useSession from "../../CustomLogout/useSession";

const PricingViewData = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedKey = location.state?.SelectedPartnerCode;
  const [partnerName, setpartnerName] = useState(selectedKey);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [partnerdata, setPartnerData] = useState([]);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [dataSource2, setDataSource2] = useState([]);
  const [pricingdataToSubmit, setpricingdataToSubmit] = useState([]);
  const [submitPayloadTodispay, setSubmitPayloadTodispay] = useState([]);
  const [submitPayloadTodispay2, setSubmitPayloadTodispay2] = useState([]);
  const [catogryStatus, setCatogryStatus] = useState("Approved");
  const [categoryData1, setCategoryData] = useState([]);
  const [dataWithStage, setDataWithStage] = useState([]);
  const [selectedPricingType, setSelectedPricingType] = useState(null);
  const [selectedPricingDetails, setSelectedPricingDetails] = useState([]);
  const [selectedPricingDetailFixed, setSelectedPricingDetailFixed] =
    useState(null);
  const [checkerAction, setCheckerAction] = useState(false);
  const [queryAction, setQueryAction] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({
    Approve: [],
    Reject: [],
    Query: [],
  });
  const [isRemarkModalVisible, setIsRemarkModalVisible] = useState(false);
  const [newRemarkcomment, setNewRemarkcomment] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const handleSessionExpired = useSession();
  const partnerDataget = useCallback(
    () => props.partnerData,
    [props.partnerData]
  );
  const partnerPricingDataWithStageget = useCallback(
    () => props.partnerPricingDataWithStage,
    [props.partnerPricingDataWithStage]
  );
  const [isLoaded, setIsLoaded] = useState(false);



  const groupByPricingCode = (data) => {
    const groupedData = data.reduce((acc, item) => {
      const key = `${item.pricingCode}-${item.effectiveDate}`;

      if (!acc[key]) {
        acc[key] = {
          ...item,
          slabs: [],
          allPricingRemarks: [],
        };
      }

      // Add slabs based on priceTypeId
      if (item.priceTypeId === 2) {
        acc[key].slabs.push({
          MinimumSlab: item.startSlab,
          MaximumSlab: item.endSlab,
          Percentage: item.percentage,
          pricingId: item.pricingId ? item.pricingId : 0,
        });
      } else if (acc[key].slabs.length === 0) {
        acc[key].slabs.push({
          MinimumSlab: 0,
          MaximumSlab: 0,
          Percentage: item.percentage,
          pricingId: item.pricingId ? item.pricingId : 0,
        });
      }

      // Merge pricingRemarks into allPricingRemarks
      if (item.pricingRemarks) {
        acc[key].allPricingRemarks = [
          ...acc[key].allPricingRemarks,
          ...item.pricingRemarks,
        ];
      }

      return acc;
    }, {});

    // Group by unique EffDate
    const groupedByEffDate = Object.values(groupedData).reduce((acc, item) => {
      const effDateKey = item.effectiveDate;

      if (!acc[effDateKey]) {
        acc[effDateKey] = [];
      }

      acc[effDateKey].push({
        disbursement: item.trancheId,
        partnerCode: item.partnerId,
        Business: item.businessId,
        Segment: item.segmentId,
        Stream: item.streamId,
        Pricing: item.priceTypeId,
        pricingCode: item.pricingCode,
        country: item.countryId,
        EffDate: item.effectiveDate,
        retrospective: item.retrospective,
        ApprovalStage: item.approvalStageId,
        pricingDetails: item.slabs,
        allPricingRemarks: item.allPricingRemarks, // Include merged remarks
        tracId: item.tracId,
      });

      return acc;
    }, {});

    // Convert grouped data into the desired format
    const dataiso = Object.entries(groupedByEffDate).map(([EffDate, items]) => ({
      EffDate,
      items,
    }));

   

    return dataiso;
  };


  

  const fetchData = async () => {
    if (isLoaded) return; // Prevent multiple calls 
  try {
    setIsLoaded(true); // Set to true to prevent further calls
    const result = props.partnerData({
      accessToken: props.accessToken,
    });
    const getcategoryData = props.categorySetup({
      accessToken: props.accessToken,
    });
    const resCategoryData = await getcategoryData;
    setCategoryData(resCategoryData);

    

    const partnerpricingData2 = await props.pricingDataWithStage({
      accessToken: props.accessToken,
      partnerFirmId: selectedKey,
    });

    if (partnerpricingData2) {
      // Enhanced 403 check for partnerpricingData2
      const errorCode =
        partnerpricingData2?.response?.data?.error?.errorCode ||
        partnerpricingData2.errorCode;
      const status =
        partnerpricingData2?.status ||
        partnerpricingData2?.response?.status;

      if (
        errorCode === "403" ||
        status === 403
      ) {
        if (
          partnerpricingData2?.data?.error?.logoutStatus ||
          partnerpricingData2?.response?.data?.error?.logoutStatus
        ) {
          handleSessionExpired();
          return; // Stop further execution
        }
      }
    }

    const newPartnerdata = await result;

    if (newPartnerdata) {
      const errorCode =
        newPartnerdata?.response?.data?.error?.errorCode ||
        newPartnerdata.errorCode;
      const errorMessage =
        newPartnerdata?.response?.data?.error?.message ||
        newPartnerdata.message;

      if (
        errorCode === "403" &&
        (newPartnerdata?.data?.error?.logoutStatus ||
          newPartnerdata?.response?.data?.error?.logoutStatus)
      ) {
        handleSessionExpired();
        return; // Stop further execution
      }
      handleRadioChange(catogryStatus, partnerpricingData2);
      setPartnerData(newPartnerdata);
      if (partnerpricingData2) {
        setDataWithStage(partnerpricingData2);
      }

      const prtnerlableName = newPartnerdata?.filter(
        (item) => item.partnerFirmId == selectedKey
      );

      setpartnerName(
        `${prtnerlableName[0].partnerFirmName}/${prtnerlableName[0].partnerDisplayCode}`
      );
    } else {
      console.error("newPartnerdata is undefined");
    }

    

  } catch (e) {
    // Check for 403 in error object (AxiosError)
    if (e?.status === 403 || e?.response?.status === 403) {
      handleSessionExpired();
      return;
    }
    console.log(e);
  }
};

  const handleDisplayData = (data) => {
    
    const groupedData = {};

    data.forEach((item) => {
      const effDate = item.EffDate;
      const found1stTrancItem = item.items.find(
        (record) => record?.disbursement === 1
      );
      const found2stTrancItem = item.items.find(
        (record) => record?.disbursement === 2
      );

      if (!groupedData[effDate]) {
        groupedData[effDate] = {
          EffDate: effDate,
          items: [],
        };
      }

      if (found1stTrancItem) {
        groupedData[effDate].items.push(found1stTrancItem);
      }
      if (found2stTrancItem) {
        groupedData[effDate].items.push(found2stTrancItem);
      }
    });

    const displayJson = Object.values(groupedData);
    
    return displayJson;
  };

  useEffect(() => {
    fetchData();

    console.log("checkerAction", checkerAction);
    
    

  }, [refresh, props.partnerPricingDataWithStage, partnerDataget, partnerPricingDataWithStageget, catogryStatus]);

  useEffect(() => {
    setSubmitPayloadTodispay(groupByPricingCode(pricingdataToSubmit));
  }, [pricingdataToSubmit]);

  useEffect(() => {
    const sData = handleDisplayData(submitPayloadTodispay)
    
    setSubmitPayloadTodispay2(handleDisplayData(submitPayloadTodispay));
  }, [submitPayloadTodispay]);

 

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const handleViewPricingDetails = (record, pricingType) => {
    
    setSelectedPricingType(pricingType);
    
    if (pricingType === "Slab") {
      setSelectedPricingDetails([...record].sort((a, b) => a.MinimumSlab - b.MinimumSlab));
    } else {
      setSelectedPricingDetailFixed(record?.[record.length - 1]);
      
    }

    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setIsRemarkModalVisible(false);
  };

  const handleOpenremark = () => {
    setIsRemarkModalVisible(true);
  };


  const handleResolvePricingDetails = (record) => {

    const sendQueryData = submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)
    
    navigate(`/PayoutMakerDashBoard/ResolvePricing`, {
      state: { SelectedPartnerCode: selectedKey, sendQueryData: sendQueryData[0].items },
      replace: true,
    });


  }



  const handleSaveAndSubmitPricingStage = async () => {

    if (
    !newRemarkcomment ||
    typeof newRemarkcomment !== "string" ||
    newRemarkcomment.trim().length === 0
    ) {
        setIsRemarkModalVisible(true);
        message.error("Please add some comment");
        return 0;
    }

    const createPayload = (items, approvalStageId) => {
      const flattenedItems = items.flat();
      return flattenedItems.map((item) => ({
        pricingId: item.pricingId,
        approvalStageId,
        remarks: newRemarkcomment,
        userRole: props.userDetail?.roleName,
      }));
    };

    const payloaddata = [
      ...createPayload(selectedCheckboxes.Query || [], 2),
      ...createPayload(selectedCheckboxes.Reject || [], 5),
      ...createPayload(selectedCheckboxes.Approve || [], 4),
    ];


    if (payloaddata.length > 0) {
      try {
        const response = await axios({
          method: "post",
          url: `${Payout_Service}/pricing/save/remarks-stages/${selectedKey}`,
          // url: `http://localhost:8301/partner-payout-service/pricing/save/remarks-stages/${selectedKey}`,
          headers: {
            authorization: "Bearer " + props.accessToken,
            "Access-Control-Allow-Origin": "*",
          },
          data: payloaddata,
        });

        if (response.status >= 200 && response.status < 300) {
          
          message.success("Submitted successfully");
          // Reset state after successful submission
          setIsRemarkModalVisible(false);
          setNewRemarkcomment(null);
          setSelectedCheckboxes({
            Approve: [],
            Reject: [],
            Query: [],
          });


          // Optionally increment refresh state
          setRefresh((prev) => prev + 1);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          const error = new Error(response.statusText);
          
          throw error;
        }
      } catch (error) {
        console.error("Error updating pricing stage:", error);

        // Reset state even if there's an error
        setIsRemarkModalVisible(false);
        setNewRemarkcomment(null);
        setSelectedCheckboxes({
          Approve: [],
          Reject: [],
          Query: [],
        });
      }
    }
  };




  const options = [
    { label: "Approved", value: "Approved" },
    { label: "Pending For Approval", value: "PendingForApproval" },
    { label: "Query", value: "Query" },
    { label: "Resolved", value: "Resolved" },
    { label: "Rejected", value: "Rejected" },
  ];

  // const columns = [
  //   {
  //     title: "Date",
  //     dataIndex: "EffDate",
  //     key: "EffDate",
  //   },
  //   ...(checkerAction ?
  //     [{
  //       title: (
  //         {
  //           label: "Action"
  //         }
  //       ),
  //       // dataIndex: "Action",
  //       key: "Action",
  //       render: (_, record) => (
  //         <div className="btn-container" style={{ display: "flex", float: "right" }}>
  //           {/* <span>EffDate</span> */}
  //           <Button style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }} onClick={(e) => handleSelectAllChange(e, "Approve", record.EffDate)} className="">Approve</Button>
  //           <Button style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }} onClick={(e) => handleSelectAllChange(e, "Query", record.EffDate)} className="">Query</Button>
  //           <Button style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }} onClick={(e) => handleSelectAllChange(e, "Reject", record.EffDate)} className="">Reject</Button>
  //         </div>
  //       )
  //     }] : []
  //   ),
  //    ...(queryAction ? [{
  //     title: "Action",
  //     dataIndex: "QueryResolve",
  //     // fixed: "left",
  //     // width: 60,
  //     render: (_, record) => (
  //         <div className="btn-container" style={{ display: "flex", float: "right" }}>
  //           {/* <span>EffDate</span> */}
  //           <Button style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }} onClick={(e) => handleResolvePricingDetails(record)} className="">Reolve Query</Button>
  //         </div>
  //       )
  //   }] : []),
  // ];



  const getMainColumns = () => [
    {
      title: "Date",
      dataIndex: "EffDate",
      key: "EffDate",
    },
    ...(checkerAction
      ? [
        {
          title: "Action",
          key: "Action",
          render: (_, record) =>
            expandedRowKeys.includes(record.key) ? (
              <div className="btn-container" style={{ display: "flex", float: "right" }}>
                <Button
                  style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }}
                  onClick={(e) => handleSelectAllChange(e, "Approve", record.EffDate)}
                >
                  Approve
                </Button>
                <Button
                  style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }}
                  onClick={(e) => handleSelectAllChange(e, "Query", record.EffDate)}
                >
                  Query
                </Button>
                <Button
                  style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }}
                  onClick={(e) => handleSelectAllChange(e, "Reject", record.EffDate)}
                >
                  Reject
                </Button>
              </div>
            ) : null,
        },
      ]
      : []),
    ...(queryAction
      ? [
        {
          title: "Action",
          dataIndex: "QueryResolve",
          key: "QueryResolve",
          render: (_, record) =>
            expandedRowKeys.includes(record.key) ? (
              <div className="btn-container" style={{ display: "flex", float: "right" }}>
                <Button
                  style={{ backgroundColor: "#1b8593", color: "#fff", borderRadius: 5, marginLeft: 10 }}
                  onClick={() => handleResolvePricingDetails(record)}
                >
                  Resolve Query
                </Button>
              </div>
            ) : null,
        },
      ]
      : []),
  ];



  // Expanded table columns (show Action column here)
  const getExpandColumns = (record) => [
    {
      title: "Disbursement Type",
      dataIndex: "disbursement",
      key: "disbursement",
      align: "center",
    },
    // {
    //   title: "Partner Code",
    //   dataIndex: "partnerCode",
    //   key: "partnerCode",
    //   align: "right"
    // },
    // {
    //   title: "Business",
    //   dataIndex: "Business",
    //   key: "Business",
    //   align: "left"
    // },
    // {
    //   title: "Segment",
    //   dataIndex: "Segment",
    //   key: "Segment",
    //   align: "left"
    // },
    // {
    //   title: "Stream",
    //   dataIndex: "Stream",
    //   key: "Stream",
    //   align: "left"
    // },
    // {
    //   title: "Country",
    //   dataIndex: "country",
    //   key: "country",
    //   align: "left"
    // },
    {
      title: "Pricing Type",
      dataIndex: "Pricing",
      key: "Pricing",
      align: "center",
    },
    // {
    //   title: "Pricing Code",
    //   dataIndex: "pricingCode",
    //   key: "pricingCode",
    //   align: "left"
    // },
    {
      title: "Pricing Percentage",
      dataIndex: "PricingID",
      key: "PricingID",
      align: "center",
    },
    {
      title: "Retrospective",
      dataIndex: "retrospective",
      key: "retrospective",
      align: "center",
    },
    {
      title: "Effective Date",
      dataIndex: "EffDate",
      key: "EffDate",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "ApprovalStage",
      key: "ApprovalStage",
      align: "center",
    },
    {
      title: "Remark",
      dataIndex: "Remark",
      key: "Remark",
      align: "center",
      fixed: "right",
    },
    // ...(checkerAction
    //   ? [
    //       {
    //         title: (record) => (
    //           <Checkbox
    //             onChange={(e) => handleSelectAllChange(e, "Approve", record.EffDate)}
    //             checked={
    //               selectedCheckboxes.Approve.length ===
    //               submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
    //             }
    //           >
    //             Approve
    //           </Checkbox>
    //         ),
    //         dataIndex: "Approve",
    //         key: "Approve",
    //         fixed: "left",
    //         width: 60,
    //       },
    //       {
    //         title: (record) => (
    //           <Checkbox
    //             onChange={(e) => handleSelectAllChange(e, "Reject", record.EffDate)}
    //             checked={
    //               selectedCheckboxes.Reject.length ===
    //               submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
    //             }
    //           >
    //             Reject
    //           </Checkbox>
    //         ),
    //         dataIndex: "Reject",
    //         key: "Reject",
    //         fixed: "left",
    //         width: 60,
    //       },
    //       {
    //         title: (record) => (
    //           <Checkbox
    //             onChange={(e) => handleSelectAllChange(e, "Query", record.EffDate)}
    //             checked={
    //               selectedCheckboxes.Query.length ===
    //               submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
    //             }
    //           >
    //             Query
    //           </Checkbox>
    //         ),
    //         dataIndex: "Query",
    //         key: "Query",
    //         fixed: "left",
    //         width: 60,
    //       },
    //     ]
    //   : []),
    // ...(queryAction ? [{
    //   title: (record) => (
    //     <Button
    //       onClick={() => handleResolvePricingDetails(record)}
    //       style={{ background: "#1b8593", color: "#fff" }}
    //     >
    //       Resolve Query
    //     </Button>
    //   ),
    //   fixed: "left",
    //   width: 60,
    // }] : []),
  ];


  // const expandColumns = [
  //   // ...(checkerAction
  //   //   ? [
  //   //     {
  //   //       title: (record) => (
  //   //         <Checkbox
  //   //           onChange={(e) => handleSelectAllChange(e, "Approve", record.EffDate)}
  //   //           checked={
  //   //             selectedCheckboxes.Approve.length ===
  //   //             submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
  //   //           }
  //   //         >
  //   //           Approve
  //   //         </Checkbox>
  //   //       ),
  //   //       dataIndex: "Approve",
  //   //       key: "Approve",
  //   //       fixed: "left",
  //   //       width: 60,

  //   //     },
  //   //     {
  //   //       title: (record) => (
  //   //         <Checkbox
  //   //           onChange={(e) => handleSelectAllChange(e, "Reject", record.EffDate)}
  //   //           checked={
  //   //             selectedCheckboxes.Reject.length ===
  //   //             submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
  //   //           }
  //   //         >
  //   //           Reject
  //   //         </Checkbox>
  //   //       ),
  //   //       dataIndex: "Reject",
  //   //       key: "Reject",
  //   //       fixed: "left",
  //   //       width: 60,
  //   //     },
  //   //     {
  //   //       title: (record) => (
  //   //         <Checkbox
  //   //           onChange={(e) => handleSelectAllChange(e, "Query", record.EffDate)}
  //   //           checked={
  //   //             selectedCheckboxes.Query.length ===
  //   //             submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
  //   //           }
  //   //         >
  //   //           Query
  //   //         </Checkbox>
  //   //       ),
  //   //       dataIndex: "Query",
  //   //       key: "Query",
  //   //       fixed: "left",
  //   //       width: 60,
  //   //     },
  //   //   ]
  //   //   : []),
  //   // ...(queryAction ? [{
  //   //   title: "Action",
  //   //   dataIndex: "QueryResolve",
  //   //   fixed: "left",
  //   //   width: 60,
  //   // }] : []),
  //   {
  //     title: "Disbursement Type",
  //     dataIndex: "disbursement",
  //     key: "disbursement",
  //     align: "center",
  //   },
  //   // {
  //   //   title: "Partner Code",
  //   //   dataIndex: "partnerCode",
  //   //   key: "partnerCode",
  //   //   align: "right"
  //   // },
  //   // {
  //   //   title: "Business",
  //   //   dataIndex: "Business",
  //   //   key: "Business",
  //   //   align: "left"
  //   // },
  //   // {
  //   //   title: "Segment",
  //   //   dataIndex: "Segment",
  //   //   key: "Segment",
  //   //   align: "left"
  //   // },
  //   // {
  //   //   title: "Stream",
  //   //   dataIndex: "Stream",
  //   //   key: "Stream",
  //   //   align: "left"
  //   // },
  //   // {
  //   //   title: "Country",
  //   //   dataIndex: "country",
  //   //   key: "country",
  //   //   align: "left"
  //   // },
  //   {
  //     title: "Pricing Type",
  //     dataIndex: "Pricing",
  //     key: "Pricing",
  //     align: "center",
  //   },
  //   // {
  //   //   title: "Pricing Code",
  //   //   dataIndex: "pricingCode",
  //   //   key: "pricingCode",
  //   //   align: "left"
  //   // },
  //   {
  //     title: "Pricing Percentage",
  //     dataIndex: "PricingID",
  //     key: "PricingID",
  //     align: "center",
  //   },
  //   {
  //     title: "Retrospective",
  //     dataIndex: "retrospective",
  //     key: "retrospective",
  //     align: "center",
  //   },
  //   {
  //     title: "Effective Date",
  //     dataIndex: "EffDate",
  //     key: "EffDate",
  //     align: "center",
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "ApprovalStage",
  //     key: "ApprovalStage",
  //     align: "center",
  //   },
  //   {
  //     title: "Remark",
  //     dataIndex: "Remark",
  //     key: "Remark",
  //     align: "center",
  //     fixed: "right",
  //   },
  //   // ...(checkerAction
  //   //   ? [
  //   //       {
  //   //         title: (record) => (
  //   //           <Checkbox
  //   //             onChange={(e) => handleSelectAllChange(e, "Approve", record.EffDate)}
  //   //             checked={
  //   //               selectedCheckboxes.Approve.length ===
  //   //               submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
  //   //             }
  //   //           >
  //   //             Approve
  //   //           </Checkbox>
  //   //         ),
  //   //         dataIndex: "Approve",
  //   //         key: "Approve",
  //   //         fixed: "left",
  //   //         width: 60,
  //   //       },
  //   //       {
  //   //         title: (record) => (
  //   //           <Checkbox
  //   //             onChange={(e) => handleSelectAllChange(e, "Reject", record.EffDate)}
  //   //             checked={
  //   //               selectedCheckboxes.Reject.length ===
  //   //               submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
  //   //             }
  //   //           >
  //   //             Reject
  //   //           </Checkbox>
  //   //         ),
  //   //         dataIndex: "Reject",
  //   //         key: "Reject",
  //   //         fixed: "left",
  //   //         width: 60,
  //   //       },
  //   //       {
  //   //         title: (record) => (
  //   //           <Checkbox
  //   //             onChange={(e) => handleSelectAllChange(e, "Query", record.EffDate)}
  //   //             checked={
  //   //               selectedCheckboxes.Query.length ===
  //   //               submitPayloadTodispay.filter((item) => item.EffDate === record.EffDate)[0].items.length
  //   //             }
  //   //           >
  //   //             Query
  //   //           </Checkbox>
  //   //         ),
  //   //         dataIndex: "Query",
  //   //         key: "Query",
  //   //         fixed: "left",
  //   //         width: 60,
  //   //       },
  //   //     ]
  //   //   : []),
  //     // ...(queryAction ? [{
  //     //   title: (record) => (
  //     //     <Button
  //     //       onClick={() => handleResolvePricingDetails(record)}
  //     //       style={{ background: "#1b8593", color: "#fff" }}
  //     //     >
  //     //       Resolve Query
  //     //     </Button>
  //     //   ),
  //     //   fixed: "left",
  //     //   width: 60,
  //     // }] : []),

  // ]


  const mapCategoryValues = (item, categoryData) => {
    
    const getCategoryName = (categoryType, id) => {
      const category = categoryData[categoryType]?.find(
        (cat) => cat.catId === id
      );

      return category ? category.catName : null;
    };

    const formatRemarks = (remarks) => {
      // Sort remarks by createdDate descending
      const sortedRemarks = remarks
        ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)) || [];

      // Use a Map to keep only one remark per unique createdDate (to the minute)
      const uniqueRemarksMap = new Map();
      sortedRemarks.forEach((remark) => {
        const dateObj = new Date(remark.createdDate);
        // Key: YYYY-MM-DD HH:MM (group by minute)
        const dateKey = dateObj.getFullYear() +
          "-" + String(dateObj.getMonth() + 1).padStart(2, "0") +
          "-" + String(dateObj.getDate()).padStart(2, "0") +
          " " + String(dateObj.getHours()).padStart(2, "0") +
          ":" + String(dateObj.getMinutes()).padStart(2, "0");
        if (!uniqueRemarksMap.has(dateKey)) {
          uniqueRemarksMap.set(dateKey, remark);
        }
      });

      // Map over unique remarks
      return Array.from(uniqueRemarksMap.values()).map((remark) => (
        <div key={remark.pricingRemarkId}>
          <b>{remark.userRole}:</b>
          <br /> {remark.remarks} <br />
          <small>
            {new Date(remark.createdDate).toLocaleString()}|
            {getCategoryName("approvalStage", remark.approvalStageId)}
          </small>
        </div>
      ));
    };

    const resRemarkdata = formatRemarks(item.allPricingRemarks);

    return {
      ...item,
      disbursement: getCategoryName("tranche", item.disbursement),
      Business: getCategoryName("business", item.Business),
      Segment: getCategoryName("segment", item.Segment),
      Stream: getCategoryName("stream", item.Stream),
      Pricing: getCategoryName("priceType", item.Pricing),
      PricingID: (
        <Button
          type="link"
          onClick={() =>
            handleViewPricingDetails(
              item.pricingDetails,
              getCategoryName("priceType", item.Pricing)
            )
          }
          style={{ background: "#1b8593", color: "#fff" }}
        >
          <EyeOutlined style={{ paddingBottom: "5px" }} />
        </Button>
      ),
      country: getCategoryName("country", item.country),
      ApprovalStage: getCategoryName("approvalStage", item.ApprovalStage),
      Remark: (
        <Dropdown
          overlay={
            <div
              style={{
                backgroundColor: "#fff",
                padding: "10px",
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              {resRemarkdata}
            </div>
          }
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space style={{ color: "#000" }}>
              <UnorderedListOutlined />
            </Space>
          </a>
        </Dropdown>
      ),
      operations: (
        <div
          style={{
            color: "#000",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DeleteOutlined />
        </div>
      ),

      // QueryResolve: (
      //   <Button onClick={() => handleResolvePricingDetails(item)}
      //     style={{ background: "#1b8593", color: "#fff" }}>Resolve Query</Button>
      // ),


    };
  };







  const handleRadioChange = (value, data = null) => {
    // console.log(e.target.value);
    // const PratnerFromState = partnersdata1;
    const PratnerFromState = props.pricingDataWithStage1
      ? props.pricingDataWithStage1
      : dataWithStage;
    
    setSelectedCheckboxes({
      Approve: [],
      Reject: [],
      Query: [],
    });

    switch (value) {
      case "Approved":
        const approvedData =
          data == null
            ? PratnerFromState?.filter((item) => item.approvalStageId === 4)
            : data.filter((item) => item.approvalStageId === 4);

        setCheckerAction(false);
        setQueryAction(false);
        if (approvedData.length > 0) {
          setpricingdataToSubmit(approvedData[0].pricingDto);
        } else {
          setpricingdataToSubmit([]);
        }
        
        setCatogryStatus("Approved");
        break;

      case "PendingForApproval":
        const PendingForApprovalData = PratnerFromState?.filter(
          (item) => item.approvalStageId === 1
        );

        setCheckerAction(props.checkerAction);
        setQueryAction(false);
        if (PendingForApprovalData.length > 0) {
          setpricingdataToSubmit(PendingForApprovalData[0].pricingDto);
        } else {
          setpricingdataToSubmit([]);
        }
        
        setCatogryStatus("PendingForApproval");
        break;

      case "Query":
        const QueryData = PratnerFromState?.filter(
          (item) => item.approvalStageId === 2
        );

        setCheckerAction(false);
        setQueryAction(props.queryAction);
        if (QueryData.length > 0) {
          setpricingdataToSubmit(QueryData[0].pricingDto);
        } else {
          setpricingdataToSubmit([]);
        }
        
        setCatogryStatus("Query");
        break;

      case "Resolved":
        const ResolvedData = PratnerFromState?.filter(
          (item) => item.approvalStageId === 3
        );

        setCheckerAction(props.checkerAction);
        setQueryAction(false);
        if (ResolvedData.length > 0) {
          setpricingdataToSubmit(ResolvedData[0].pricingDto);
        } else {
          setpricingdataToSubmit([]);
        }
        
        setCatogryStatus("Resolved");
        break;

      case "Rejected":
        const RejectedData = PratnerFromState?.filter(
          (item) => item.approvalStageId === 5
        );

        setCheckerAction(false);
        setQueryAction(false);
        if (RejectedData.length > 0) {
          setpricingdataToSubmit(RejectedData[0].pricingDto);
        } else {
          setpricingdataToSubmit([]);
        }
        
        setCatogryStatus("Rejected");
        break;

      default:
        // Handle default case or reset state
        setpricingdataToSubmit([]);
        break;
    }
  };

  const handleCheckboxChange = (e, column, rowId) => {
    const value = e.target.value;
    setSelectedCheckboxes((prevState) => {
      const newState = {
        Approve: prevState.Approve.filter((item) => item !== rowId),
        Reject: prevState.Reject.filter((item) => item !== rowId),
        Query: prevState.Query.filter((item) => item !== rowId),
      };
      newState[column] = prevState[column].includes(rowId)
        ? newState[column].filter((item) => item !== rowId)
        : [...newState[column], rowId];
      return newState;
    });
    
  };

  const handleSelectAllChange = (e, column, EffDate) => {
    



    setSelectedCheckboxes({
      Approve: [],
      Reject: [],
      Query: [],
    });
    const checked = e.target.checked;
    
    const filteredData = submitPayloadTodispay.filter(
      (item) => item.EffDate === EffDate
    );

   
    const allValues = filteredData[0].items.map((item) => item.pricingDetails);
    
    setSelectedCheckboxes((prevState) => ({
      ...prevState,
      // [column]: checked ? allValues : [],
      [column]: allValues,
    }));
    handleOpenremark();
    
  };
  useEffect(() => {
    console.log("selectedCheckboxes3", selectedCheckboxes);
  }, [selectedCheckboxes]);

  return (
    <div style={{ maxWidth: "100%" }} onDoubleClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }} >
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
           <Button
                        type="default"
                        style={{
                          margin: "0",
                          border: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2px', // space between icon and text
                          padding: '0 8px',
                          color: '#00b1b1',
                        }}
                        onClick={() => props.checkerAction === true ?  navigate('/PayoutCheckerDashBoard/PartnerPricing') : navigate('/PayoutMakerDashBoard/PartnerPricing')} //navigate to pricing dashboard
                      >
                        <LeftCircleOutlined />
                        <span>Back</span>
                      </Button>
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}

                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Col md={6} style={{ display: "flex" }} className="btn-partner">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5
                style={{ fontWeight: 700, fontSize: "0.9rem", margin: "20px" }}
              >
                Partner :{" "}
                <span style={{ color: "#35cd7a" }}>{partnerName}</span>
              </h5>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ marginTop: 30, display: "flex" }} onDoubleClick={e => {
              e.preventDefault();
              e.stopPropagation();
            }}>
          <Col md={9}>
            <Radio.Group
              block
              options={options}
              defaultValue="Approved"
              onChange={(e) => {
                handleRadioChange(e.target.value);
              }}
              optionType="button"
              buttonStyle="solid"
              buttonCheckedBg="#1b8593"
              onDoubleClick={e => {
              e.preventDefault();
              e.stopPropagation();
            }}
            />
          </Col>
          <Col
            md={3}
            style={{
              display: "flex",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
          </Col>
        </div>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>

          <Table
            columns={getMainColumns()}
            expandable={{
              expandedRowRender: (record) => (
                <div style={{ background: "#f9f9f9" }}>
                  <Table
                    columns={getExpandColumns(record)}
                    dataSource={record?.items?.map((item) => mapCategoryValues(item, categoryData1))}
                    pagination={true}
                    scroll={{ x: "max-content" }}
                     onDoubleClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  />
                </div>
              ),
              defaultExpandedRowKeys: [0],
              expandedRowKeys: expandedRowKeys,
              onExpand: (expanded, record) => {
                setExpandedRowKeys(expanded ? [record.key] : []);
              },
            }}
            dataSource={submitPayloadTodispay2.map((item, index) => ({
              ...item,
              key: index,
            }))}
            scroll={{ x: "max-content" }}
            onDoubleClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
          />


          <Modal
            title="Pricing Remark"
            visible={isRemarkModalVisible}
            onCancel={handleCloseModal}
            footer={null}
          >
            <TextArea
              placeholder="Please add comment to submit"
              onChange={(e) => setNewRemarkcomment(e.target.value)}
              autoSize={{ minRows: 2, maxRows: 6 }}
            />
            <Button
              disabled={newRemarkcomment === null || newRemarkcomment.trim().length === 0 }
              type="link"
              onClick={() => handleSaveAndSubmitPricingStage()}
              style={{ background: "#1b8593", marginTop: "0.3rem", color: "#fff" }}
            >
              Submit
            </Button>
          </Modal>
          <Modal
            title="Pricing Details"
            visible={isModalVisible}
            onCancel={handleCloseModal}
            footer={null}
          >
            {selectedPricingType === "Slab" && (
              <>
                <div></div>
                <Table
                  dataSource={selectedPricingDetails}
                  columns={[
                    {
                      title: "Minimum slab",
                      dataIndex: "MinimumSlab",
                      key: "MinimumSlab",
                    },
                    {
                      title: "Maximum slab",
                      dataIndex: "MaximumSlab",
                      key: "MaximumSlab",
                    },
                    {
                      title: "Percentage",
                      dataIndex: "Percentage",
                      key: "Percentage",
                    },
                  ]}
                  pagination={false}
                />
              </>
            )}

            {selectedPricingType === "Fixed" && (
              <>
                <div>
                  Fixed Percentage :
                  {/* <InputNumber
                      style={{ color: "#000", fontWeight: 300 }}
                      defaultValue={selectedPricingDetailFixed?.Percentage}
                      size="large"
                      min={0}
                      max={100}
                      disabled={true}
                      formatter={(value) => `${value}%`}
                      parser={(value) => value?.replace("%", "")}
                    /> */}
                  {selectedPricingDetailFixed?.Percentage + "%"}
                </div>
                <div></div>
              </>
            )}
          </Modal>
          {/* {selectedCheckboxes.Query.length > 0 ||
            selectedCheckboxes.Reject.length > 0 ||
            selectedCheckboxes.Approve.length > 0 ? (
            <>
              <Button
                // disabled={ selectedCheckboxes.Query.length === 0}
                type="link"
                onClick={() => handleOpenremark()}
                style={{
                  background: "#1b8593",
                  color: "#fff",
                  float: "right",
                  marginTop: "0.4rem",
                }}
              >
                Save and Submit
              </Button>
            </>
          ) : null} */}
        </Col>
      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    partnerData: (data) => dispatch(partnerDataSuccess(data)),
    categorySetup: (data) => dispatch(getCategoryList(data)),
    pricingDataWithStage: (data) =>
      dispatch(getPartnerPricingDataByStage(data)),
    upatePricingStage: (data) => dispatch(addPricingStageByPartner(data)),
  };
};

const mapStateToProps = (state) => {
 
  return {
    partnersdata1: state.pricigPartner.state.partnerDetail,
    pricingDataWithStage1:
      state.partnerPricingDataWithStage.state.state.partnerPricingDataWithStage,
    loading: state.pricigPartner.loading,
    error: state.pricigPartner.error,
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingViewData);
